import React, { useState, useEffect } from 'react';
import { Route, Switch } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';

//import { Gatekeeper } from 'gatekeeper-client-sdk';

import { loadUser, logoutUser } from '@store/reducers/auth';
import { toggleSidebarMenu } from '@app/store/reducers/ui';
import * as AuthService from '../../services/auth';
import Dashboard from '@pages/Dashboard';
import Blank from '@pages/Blank';
import Profile from '@pages/profile/Profile';
import PhanquyenList from '@app/pages/FPhanquyen/PhanquyenList';
import { PhanquyenEdit } from '@app/pages/FPhanquyen/PhanquyenEdit';

import Header from './header/Header';
import Footer from './footer/Footer';
import MenuSidebar from './menu-sidebar/MenuSidebar';
import PageLoading from '../../components/page-loading/PageLoading';
import {alertService} from "@app/services/alertService";
import * as mainService from '@app/services/mainService';
import UserList from '@app/pages/FMasterData/FUser/UserList';
import { UserEdit } from '@app/pages/FMasterData/FUser/UserEdit';
import MauList from "@pages/FMasterData/FMau/MauList";
import {MauEdit} from "@pages/FMasterData/FMau/MauEdit";
import LoaiphuchinhList from "@pages/FMasterData/FLoaiphuchinh/LoaiphuchinhList";
import {LoaiphuchinhEdit} from "@pages/FMasterData/FLoaiphuchinh/LoaiphuchinhEdit";
import DonvitinhList from "@pages/FMasterData/FDonvitinh/DonvitinhList";
import {DonvitinhEdit} from "@pages/FMasterData/FDonvitinh/DonvitinhEdit";
import NhanvienList from "@pages/FMasterData/FNhanvien/NhanvienList";
import {NhanvienEdit} from "@pages/FMasterData/FNhanvien/NhanvienEdit";
import KhachhangList from "@pages/FMasterData/FKhachhang/KhachhangList";
import {KhachhangEdit} from "@pages/FMasterData/FKhachhang/KhachhangEdit";
import SanphamList from "@pages/FMasterData/FSanpham/SanphamList";
import {SanphamEdit} from "@pages/FMasterData/FSanpham/SanphamEdit";
import {DonhangEdit} from "@pages/FDonhang/DonhangEdit";
import DonhangList from "@pages/FDonhang/DonhangList";
import BanggiaList from "@pages/FMasterData/FBanggia/BanggiaList";
import {BanggiaEdit} from "@pages/FMasterData/FBanggia/BanggiaEdit";
import NhomnhanvienList from "@pages/FMasterData/FNhomnhanvien/NhomnhanvienList";
import {NhomnhanvienEdit} from "@pages/FMasterData/FNhomnhanvien/NhomnhanvienEdit";
import PhieuthutienList from "@pages/FMasterData/FPhieuthutien/PhieuthutienList";
import {PhieuthutienEdit} from "@pages/FMasterData/FPhieuthutien/PhieuthutienEdit";
import ActivityLogViewer from "@pages/FLogs/ActivityLogViewer";
import ExportInvoice from "@pages/FReports/ExportInvoice";
import ExportNhanvienReport from "@pages/FReports/ExportNhanvienReport";
import ExportOrderDetailReport from "@pages/FReports/ExportOrderDetailReport";
const Main = () => {
	const dispatch = useDispatch();
	const isSidebarMenuCollapsed = useSelector((state) => state.ui.isSidebarMenuCollapsed);
	const screenSize = useSelector((state) => state.ui.screenSize);
	const [appLoadingState, updateAppLoading] = useState(false);
	const userTmp =  localStorage.getItem("profile");
	let view_navigate = true;
	if(userTmp  )
	{
		const nv = JSON.parse(userTmp);
		if(nv && nv.role && nv.role.length > 0 && nv.role.includes("SALEMAN") )
			view_navigate = false;
	}

	const handleToggleMenuSidebar = () => {
		dispatch(toggleSidebarMenu());
	};

	const loadStore = async () => {
		await mainService.getAllTrangthai(dispatch);
		//await icdService.getAllICD(dispatch);
		//await nhacungcapService.getAllNCC(dispatch);
	};
	const fetchProfile = async () => {
		try {
			const res = await AuthService.verify_token();

			if(!res.flag)
			{
				alertService.info(res.msg,);
				dispatch(logoutUser());

			}
			
			updateAppLoading(false);

		} catch (error) {
			dispatch(logoutUser());
			updateAppLoading(false);
		}
	};
	useEffect(async () => {

		

		await fetchProfile();
		const intervalId = setInterval(fetchProfile, 10 * 60 * 1000);

		return () => clearInterval(intervalId);
	}, [dispatch]);

	useEffect(() => {
			

		updateAppLoading(true);
		loadStore();
		

		document.getElementById('root').classList.remove('register-page');
		document.getElementById('root').classList.remove('login-page');
		document.getElementById('root').classList.remove('hold-transition');
		document.getElementById('root').classList.add('sidebar-mini');
		document.getElementById('root').classList.add('layout-fixed');

		return () => {
			document.getElementById('root').classList.remove('sidebar-mini');
			document.getElementById('root').classList.remove('layout-fixed');
		};

	}, []);

	useEffect(() => {
		document.getElementById('root').classList.remove('sidebar-closed');
		document.getElementById('root').classList.remove('sidebar-collapse');
		document.getElementById('root').classList.remove('sidebar-open');
		if (isSidebarMenuCollapsed && screenSize === 'lg') {
			document.getElementById('root').classList.add('sidebar-collapse');
		} else if (isSidebarMenuCollapsed && screenSize === 'xs') {
			document.getElementById('root').classList.add('sidebar-open');
		} else if (!isSidebarMenuCollapsed && screenSize !== 'lg') {
			document.getElementById('root').classList.add('sidebar-closed');
			document.getElementById('root').classList.add('sidebar-collapse');
		}

	}, [screenSize, isSidebarMenuCollapsed]);

	let template;

	if (appLoadingState) {
		template = <PageLoading />;
	} else {
		template = (
			<>
				<Header toggleMenuSidebar={handleToggleMenuSidebar} />

				{view_navigate && <MenuSidebar />}
				<div className="content-wrapper">

				<div className="pt-3" />
					<section className="content">
						<Switch>
							<Route exact path="/sub-menu-2" component={Blank} />
							<Route exact path="/AUTHORITies" component={PhanquyenList} />
							<Route exact path="/AUTHORITies/add" component={PhanquyenEdit} />
							<Route exact path="/AUTHORITies/edit/:id" component={PhanquyenEdit} />
							<Route exact path="/AUTHORITies/view/:id" component={PhanquyenEdit} />

							<Route exact path="/MEMBERs" component={UserList} />
							<Route exact path="/MEMBERs/add" component={UserEdit} />
							<Route exact path="/MEMBERs/edit/:id" component={UserEdit} />
							<Route exact path="/MEMBERs/view/:id" component={UserEdit} />

							<Route exact path="/color" component={MauList} />
							<Route exact path="/color/add" component={MauEdit} />
							<Route exact path="/color/edit/:id" component={MauEdit} />
							<Route exact path="/color/view/:id" component={MauEdit} />

							<Route exact path="/loaiphuchinh" component={LoaiphuchinhList} />
							<Route exact path="/loaiphuchinh/add" component={LoaiphuchinhEdit} />
							<Route exact path="/loaiphuchinh/edit/:id" component={LoaiphuchinhEdit} />
							<Route exact path="/loaiphuchinh/view/:id" component={LoaiphuchinhEdit} />

							<Route exact path="/nhomnhanvien" component={NhomnhanvienList} />
							<Route exact path="/nhomnhanvien/add" component={NhomnhanvienEdit} />
							<Route exact path="/nhomnhanvien/edit/:id" component={NhomnhanvienEdit} />
							<Route exact path="/nhomnhanvien/view/:id" component={NhomnhanvienEdit} />

							<Route exact path="/donvitinh" component={DonvitinhList} />
							<Route exact path="/donvitinh/add" component={DonvitinhEdit} />
							<Route exact path="/donvitinh/edit/:id" component={DonvitinhEdit} />
							<Route exact path="/donvitinh/view/:id" component={DonvitinhEdit} />

							<Route exact path="/nhanvien" component={NhanvienList} />
							<Route exact path="/nhanvien/add" component={NhanvienEdit} />
							<Route exact path="/nhanvien/edit/:id" component={NhanvienEdit} />
							<Route exact path="/nhanvien/view/:id" component={NhanvienEdit} />

							<Route exact path="/khachhang" component={KhachhangList} />
							<Route exact path="/khachhang/add" component={KhachhangEdit} />
							<Route exact path="/khachhang/edit/:id" component={KhachhangEdit} />
							<Route exact path="/khachhang/view/:id" component={KhachhangEdit} />

							<Route exact path="/sanpham" component={SanphamList} />
							<Route exact path="/sanpham/add" component={SanphamEdit} />
							<Route exact path="/sanpham/edit/:id" component={SanphamEdit} />
							<Route exact path="/sanpham/view/:id" component={SanphamEdit} />

							<Route exact path="/banggia" component={BanggiaList} />
							<Route exact path="/banggia/add" component={BanggiaEdit} />
							<Route exact path="/banggia/edit/:id" component={BanggiaEdit} />
							<Route exact path="/banggia/view/:id" component={BanggiaEdit} />

							<Route exact path="/donhang" component={DonhangList} />
							<Route exact path="/donhang/add" component={DonhangEdit} />
							<Route exact path="/donhang/edit/:id" component={DonhangEdit} />
							<Route exact path="/donhang/view/:id" component={DonhangEdit} />

							<Route exact path="/phieuthutien" component={PhieuthutienList} />
							<Route exact path="/phieuthutien/add" component={PhieuthutienEdit} />
							<Route exact path="/phieuthutien/edit/:id" component={PhieuthutienEdit} />
							<Route exact path="/phieuthutien/view/:id" component={PhieuthutienEdit} />

							<Route exact path="/logs" component={ActivityLogViewer} />
							<Route exact path="/xuathoadon" component={ExportInvoice} />
							<Route exact path="/baocaonhanvien" component={ExportNhanvienReport} />
							<Route exact path="/chitietdonhang" component={ExportOrderDetailReport} />

							<Route exact path="/profile" component={Profile} />
							<Route exact path="/"  component={Dashboard} />
							
						</Switch>
					</section>
				</div>
				<Footer />
				<div id="sidebar-overlay" role="presentation" onClick={handleToggleMenuSidebar} onKeyDown={() => {}} />
			</>
		);
	}

	return <div className="wrapper">{template}</div>;
};

export default Main;
